import { NavLink } from "react-router-dom";

import { IS_UNIVERSAL_PARTNER } from "../../../../../../constants/host-name";
import { NAVIGATION_ITEMS, RoutePaths } from "../../../../../../constants";
import { useStore, useTranslation } from '../../../../../../hooks';
import { Icon } from "../../../../shared";
import { useMemo } from 'react';

interface NavigationProps {}

export const Navigation: React.FC<NavigationProps> = () => {

  const t = useTranslation();
  const { providersStore } = useStore();
  const { providers: { data: { partnerId } } } = providersStore;

  // TODO---- HARD CODE MUST BE CHANGE
  const navigationItems = useMemo(() => {
    return partnerId === 4 ? NAVIGATION_ITEMS : NAVIGATION_ITEMS.filter((item) => item.path !== RoutePaths.Jackpot);
  }, [partnerId]);

  return (
    <>
      {!IS_UNIVERSAL_PARTNER ? (
        <NavLink to={RoutePaths.Game} className="header-logo-container">
          <span className="gravity-logo-in-header" />
        </NavLink>
      ) : null}

      {navigationItems.map(({ path, icon, label }) => (
        <NavLink
          to={path}
          key={path}
          className={({ isActive }) => `header-left-side-column ${isActive ? "active" : ""}`}
        >
          <p className="header-icon-container">
            <Icon type={icon} />
          </p>
          <span className="header-link-title">{t(label)}</span>
        </NavLink>
      ))}
    </>
  );
};
